<template>
  <main role="Penagihan">
    <PenagihanTable />
  </main>
</template>

<script>
import PenagihanTable from "../Penagihan/PenagihanTable";
export default {
  components: {
    PenagihanTable,
  },
  
  // beforeDestroy(){
  //   console.log('beforeDestroy')
  // },
  // destroyed(){
  //   console.log('destroyed')
  // },
  
  
  // beforeUpdate(){
  //   console.log('beforeUpdate')
  // },
  // updated(){
  //   console.log('updated')
  // }
  
  
};
</script>

<style>
.modal-content {
  background-color: rgb(245, 245, 245);
}
</style>